import { defineComponent } from "vue";
export default defineComponent({
    props: {
        title: {
            type: String,
            default: ""
        },
        msg: {
            type: String,
            default: ""
        },
        // 不确定是否删除msg div是否有问题，直接增加这个参数来控制
        // 没有msg就不应该显示对应的dom，影响了布局
        showMsg: {
            type: Boolean,
            default: true
        },
        emptyTransparency: {
            // 用于控制empty状态是否透明，防止empty状态在数据获取完成前闪烁
            type: Boolean,
            default: false
        }
    }
});
